import { render, staticRenderFns } from "./edit-coins.vue?vue&type=template&id=949f3fca"
import script from "./edit-coins.vue?vue&type=script&lang=js"
export * from "./edit-coins.vue?vue&type=script&lang=js"
import style0 from "./edit-coins.vue?vue&type=style&index=0&id=949f3fca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports